export default __webpack_public_path__ + "a26a619e8b16a2f23ed11e2e81faf0b6.png";